import React, { useEffect } from "react";
import { usePartnersStore } from "./stores/partnersStore";
import PartnersHeader from "./components/PartnersHeader/PartnersHeader";
import PartnersTable from "./components/PartnersTable/PartnersTable";
import {
  Loading,
  PaginationControls,
  PageHistory,
  PermissionWrapper,
} from "components";
import { partnerHistoryConfig } from "./utils/partnerHistoryConfig";

// Головний компонент сторінки "Продукція партнерів"
const PartnersPage = () => {
  // Отримуємо необхідні дані та дії зі стору
  const totalCount = usePartnersStore((state) => state.totalCount);
  const isLoading = usePartnersStore((state) => state.isLoading);
  const filters = usePartnersStore((state) => state.filters);
  const setPage = usePartnersStore((state) => state.setPage);
  const init = usePartnersStore((state) => state.init);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки.
  useEffect(() => {
    init();
  }, [init]);

  // Обчислюємо загальну кількість сторінок для пагінації
  const totalPages = Math.ceil(totalCount / filters.page_size) || 1;

  return (
    <section id="partnerspage">
      <PermissionWrapper requiredPermission="activity_log:view">
        <PageHistory subjects={["partner_property"]} config={partnerHistoryConfig} />
      </PermissionWrapper>
      <div className="page-container">
        <PartnersHeader />

        {isLoading ? (
          <Loading />
        ) : (
          <>
            <PartnersTable />
            <PaginationControls
              page={filters.page}
              totalPages={totalPages}
              onPageChange={(page) => setPage(page)}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default PartnersPage;
